export enum INBOX_SUBSCRIBE_STATUS_CODE {
    OK = 'OK'
}
